import { createSlice } from "@reduxjs/toolkit";
import { DatasetReducerType } from "../../types/DatasetTypes";

const initialState: DatasetReducerType = {
  isUploadStarted: false,
  uploadStep: 1,
};

const DatasetSlice = createSlice({
  name: "DatasetReducer",
  initialState,
  reducers: {
    setIsUploadStarted: (nextState, { payload }) => {
      nextState.isUploadStarted = payload;
    },

    updateDatasetStep: (nextState, { payload }) => {
      nextState.uploadStep = payload;
    },
    resetDatasetSlice: (nextState) => {
      nextState.isUploadStarted = false;
      nextState.uploadStep = 1;
    },
  },
});

export const {
  setIsUploadStarted,
  updateDatasetStep,
  resetDatasetSlice,
} = DatasetSlice.actions;
export const { reducer: DatasetReducer } = DatasetSlice;
